import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/price-target.svg";
var PriceTargetOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  PriceTargetOutline_default as default
};
